import vidbg from 'vidbg.js';

if (document.querySelector('.hero')) {
    const heroVideo = new vidbg('.hero__video', {
        mp4: document.querySelector('.hero__video').getAttribute('data-mp4') ?? undefined,
        webm: document.querySelector('.hero__video').getAttribute('data-webm') ?? undefined,
        overlay: true,
        overlayColor: '#1a3661',
        overlayAlpha: 0.8
    });

    if (document.querySelector('.hero__video video')) {
        document.querySelector('.hero__video video').play();
    }

    const buttonOpenVideo = document.querySelector('.js-open-company-video-modal');
    if (buttonOpenVideo) {
        buttonOpenVideo.addEventListener('click', (e) => {
            let videoUrl = buttonOpenVideo.getAttribute('data-src');
            videoUrl = videoUrl.split('?').pop();

            const videoParams = new URLSearchParams(videoUrl);
            let videoElement = document.createElement('div');
            videoElement.className = 'video-element is-visible';
            videoElement.innerHTML = `
                <div class="video-element__container">
                    <iframe src="https://www.youtube.com/embed/${videoParams.get('v')}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
            `;

            if (document.querySelector('.video-element')) {
                document.querySelector('.video-element').classList.add('is-visible');
            } else {
                document.querySelector('.hero').append(videoElement);
            }
        });

        document.addEventListener('click', (e) => {
            if (!e.target.closest('.video-element__container')) {
                if (document.querySelector('.video-element') && !e.target.closest('.js-open-company-video-modal')) {
                    document.querySelector('.video-element').classList.remove('is-visible');
                }
            }
        });
    }
}
